import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import { UpOutlined } from '@ant-design/icons';
import './scrollToTop.scss';

const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.scrollY > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    return (
        <div className="scroll-to-top">
            {isVisible &&
                <Button
                    onClick={scrollToTop}
                    type="primary"
                    shape="circle"
                    icon={<UpOutlined style={{ fontSize: 22 }} />}
                    size="large"
                    style={{
                        boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
                        background: 'linear-gradient(135deg, #36d1c4 0%, #5b86e5 100%)',
                        border: 'none',
                        color: '#fff',
                        position: 'fixed',
                        right: 32,
                        bottom: 32,
                        zIndex: 1000,
                        transition: 'background 0.3s, box-shadow 0.3s',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 56,
                        height: 56,
                        padding: 0
                    }}
                    className="scroll-to-top-modern"
                />
            }
        </div>
    );
};

export default ScrollToTop;